import { useNavigate } from 'react-router-dom';
import { RootState } from '../store';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';

const PublicRoute = ({ children }: { children: JSX.Element}) => {
    const authState = useSelector((state: RootState) => state.auth);
    const navigate = useNavigate();
    useEffect(() => {
        if (authState.companyselected) {
            if (authState.companyselected.Roles.Id === 49) {
                console.log('**** authState.companyselected.Roles.Id === 49')
                navigate('/support-login')
            } else {
                navigate('/')
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authState.companyselected])

    return children

}

export default PublicRoute;